import { createSelector } from "@reduxjs/toolkit"
import { Session } from "@/redux/_session.types"

// Module flag alone gates it for a real client account, same convention as every other
// module-gated feature (nps, rps, task...) — session.userRole is the per-user SURVEY_ROLE
// (ADMIN/MANAGER/OBSERVER), not an account-level flag, so requiring ADMIN here wrongly hid this
// from MANAGER/OBSERVER users on accounts that do have the benchmark module enabled.
// connectedAsSupervisor must NOT bypass the module flag itself — a CS "connected as" a client
// without the module must still not see it (confirmed as a real regression during testing:
// visible on CIC, module off).
// A raw supervisor session (interfaceType === "SUPERVISOR", editing a template directly from
// /supervisor/templates, no client impersonation) has no account/module flag to check at all —
// same convention as the rps/nps pastilles above (`modules.survey.rps || interfaceType ===
// "SUPERVISOR"`), always visible there. It goes through separate /supervisor/benchmark/* routes
// (see benchmarkQuestion.thunk.ts's *_AsSupervisor thunks) since that JWT carries no accountId.
export const selectCanSeeBenchmark = createSelector(
  (state: { _session: Session }) => state._session,
  (session) => session.interfaceType === "SUPERVISOR" || session.modules.survey.benchmark
)
